module.exports = __webpack_public_path__ + "static/media/g-what.89a6adb9.png";